import ProductCatalogGrid from '../../components/product-catalog';
import ContactDialog from '../../components/product-catalog/contact-dialog';
import { useChiliPiperContact } from './use-chilipiper-contact';
import { useProductCatalogShell } from './use-product-catalog-shell';

// Test implementation for docs/portal-integration-feasibility.md Appendix B (A2/A3/A5/B1-B5) —
// route-level login gate + Skylab nav override + a ported Product Catalog grid, gated behind
// the `shouldShowProductCatalog` feature flag. Kept separate from the offer template for now.
const ProductCatalog = () => {
  const {
    accountId,
    customerAccountId,
    obligations,
    user,
    isLoading,
    features,
    nextBestProduct,
    renderNavigation,
    shouldRender,
  } = useProductCatalogShell();

  const { contactDialogProduct, schedulingInProgress, contactError, handleContactClick, handleDismissDialog } =
    useChiliPiperContact(shouldRender, customerAccountId, user);

  if (!shouldRender) return null;

  return (
    <>
      {renderNavigation()}
      {accountId && !isLoading && (
        <>
          <ProductCatalogGrid
            obligations={obligations}
            onContactClick={handleContactClick}
            recommendedProductIds={nextBestProduct.productIds}
            showRecommendationEvents={!!features.SHOULDSHOWRECOMMENDATIONEVENTS}
          />
          <ContactDialog
            productTitle={contactDialogProduct?.title ?? ''}
            dialogOpen={Boolean(contactDialogProduct)}
            schedulingInProgress={schedulingInProgress}
            hasError={contactError}
            handleDismissDialog={handleDismissDialog}
          />
        </>
      )}
    </>
  );
};

export default ProductCatalog;
